export default __webpack_public_path__ + "d26f83b83a03f5c78b39abcdeabbf5f8.svg";